import { createContext, useCallback, useContext } from 'react';
import useApiService from './ApiService';
import CONFIG from './CONFIG';
import { buildUrl } from '../utils/buildQuery';
import { normalizeDate } from '../utils/formatDate';

const ConnectionLogApiContext = createContext(null);

export function ConnectionLogApiProvider({ children }) {
  const { get } = useApiService(CONFIG.SERVER_ORGANIZATION);

  const getConnectionLogs = useCallback(
    async (skip, limit, start_date, end_date) => {
      try {
        const url = buildUrl('/v1/audit/connection', {
          skip,
          limit,
          start_date: normalizeDate(start_date),
          end_date: normalizeDate(end_date),
        });

        const response = await get(url);
        return response.data;
      } catch (error) {
        console.error('Error fetching connection logs:', error);
        throw error;
      }
    },
    [get],
  );

  const getConnectionLogById = useCallback(
    async (connectionLogId) => {
      try {
        const response = await get(`/v1/audit/connection/${connectionLogId}`);
        return response.data;
      } catch (error) {
        console.error('Error fetching connection log by ID:', error);
        throw error;
      }
    },
    [get],
  );

  return (
    <ConnectionLogApiContext.Provider value={{ getConnectionLogs, getConnectionLogById }}>
      {children}
    </ConnectionLogApiContext.Provider>
  );
}

export function useConnectionLogApi() {
  const context = useContext(ConnectionLogApiContext);
  if (!context) {
    throw new Error('useConnectionLogApi must be used within a ConnectionLogApiProvider');
  }
  return context;
}
